import { emptyObj } from 'util/objects'
import { createBasicSelector } from 'util/redux'
import { selectBase } from './selectBase'

export const selectBillingUsage = createBasicSelector(
  selectBase,
  base => base.usage || emptyObj
)
